<script lang="ts">
  import RankFirstIcon from "$lib/icons/RankFirstIcon.svelte";
  import NumberFormat from "$lib/components/NumberFormat.svelte";
  import RankSecondIcon from "$lib/icons/RankSecondIcon.svelte";
  import RankThirdIcon from "$lib/icons/RankThirdIcon.svelte";
  import type {IPlacement, ITournament} from "$lib/interfaces/ITournament";
  import CurrencySymbol from "$lib/elements/CurrencySymbol.svelte";

  interface Props {
    player: IPlacement;
    tournament: ITournament;
    isMe: boolean;
  }

  let { player, tournament, isMe }: Props = $props();
</script>

<div style="{isMe ? 'box-shadow: 0 0 8px #F93C2C' :''}" class="bg-primary-blue col-span-1 grid items-center grid-cols-12 p-2 rounded-md text-sm">
  <div class="col-span-2 text-white">
    {#if player.placement === 1}
      <RankFirstIcon />
    {:else if player.placement === 2}
      <RankSecondIcon />
    {:else if player.placement === 3}
      <RankThirdIcon />
    {:else}
      <span class="ml-2.5">{player.placement}</span>
    {/if}
  </div>
  <div class="col-span-4 text-white">{player.username}</div>
  <div class="col-span-3 text-primary-lightBlue"><NumberFormat value={player.points} digitsInfo="1.0-0" locale="en-US" /></div>
  <div class="col-span-3 text-right text-nowrap {player.placement <= 3 ? 'text-primary-fire' :'text-white'}"><CurrencySymbol currency={tournament.currency.name} /> <NumberFormat value={player.prizeAmount} digitsInfo="1.2-2" /></div>
</div>
